import { AuthService } from '@account-users';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomainSetting, DomainSettingsList } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DomainSettingsService {
  constructor(
    private readonly authService: AuthService,
    private readonly http: HttpClient,
    @Inject('privateDomainUrl') private privateDomainUrl: string,
  ) {}

  getSettings() {
    return this.http.get<DomainSettingsList>(
      `${this.privateDomainUrl}settings`,
      {
        headers: new HttpHeaders().set(
          'Authorization',
          `Bearer ${this.authService.accessToken}`,
        ),
      },
    );
  }

  delete(accountId: string) {
    return this.http.delete(`${this.privateDomainUrl}settings/${accountId}`, {
      headers: new HttpHeaders().set(
        'Authorization',
        `Bearer ${this.authService.accessToken}`,
      ),
    });
  }

  save(accountDomainSetting: DomainSetting) {
    return this.http.post<DomainSetting>(
      `${this.privateDomainUrl}settings`,
      {
        ...accountDomainSetting,
      },
      {
        headers: new HttpHeaders().set(
          'Authorization',
          `Bearer ${this.authService.accessToken}`,
        ),
      },
    );
  }

  update(accountDomainSetting: DomainSetting) {
    return this.http.put<DomainSetting>(
      `${this.privateDomainUrl}settings/${accountDomainSetting.accountId}`,
      {
        ...accountDomainSetting,
      },
      {
        headers: new HttpHeaders().set(
          'Authorization',
          `Bearer ${this.authService.accessToken}`,
        ),
      },
    );
  }

  toggle(accountId: string, enabled: boolean) {
    return this.http.patch(
      `${this.privateDomainUrl}settings/${accountId}`,
      { enabled },
      {
        headers: new HttpHeaders().set(
          'Authorization',
          `Bearer ${this.authService.accessToken}`,
        ),
      },
    );
  }

  getAccountSetting(accountId: string) {
    return this.http.get<DomainSetting>(
      `${this.privateDomainUrl}settings/${accountId}`,
      {
        headers: new HttpHeaders().set(
          'Authorization',
          `Bearer ${this.authService.accessToken}`,
        ),
      },
    );
  }
}
